'use client';

import { PanelLeftCloseIcon, PanelRightCloseIcon } from 'lucide-react';
import type { VariantProps } from 'class-variance-authority';

import { useSidebar } from '@/shared/ui/components/sidebar';
import { Button } from '@/shared/ui/components/button';
import type { buttonVariants } from '@/shared/ui/components/button';

type Props = {
  className?: string;
  variant?: VariantProps<typeof buttonVariants>['variant'];
};

const MenuTrigger = ({ className, variant = 'ghost' }: Props) => {
  const { open, isMobile, openMobile, toggleSidebar } = useSidebar();

  const isOpen = isMobile ? openMobile : open;

  return (
    <Button variant={variant} size="icon" onClick={toggleSidebar} className={className}>
      {isOpen ? <PanelLeftCloseIcon /> : <PanelRightCloseIcon />}
    </Button>
  );
};

export default MenuTrigger;
